import { Dispatch } from 'redux';
import { RiskResponse } from '../../graphql/API';
import { calculateRisk } from '../../graphql/mutations';
import api from '../../services/api';
import {
  SUBMIT_ATR_REQUESTED,
  SUBMIT_ATR_COMPLETED,
  SUBMIT_ATR_FAILED,
} from './types';

interface SubmitAtrProps {
  responses: RiskResponse[];
  authMode: 'iam' | 'userPool';
  ContactID?: string;
  resourceId?: string;
}

function submitAtr(props: SubmitAtrProps) {
  return async function action(dispatch: Dispatch) {
    const { responses, authMode, ContactID, resourceId } = props;
    dispatch({
      type: SUBMIT_ATR_REQUESTED,
    });

    try {
      const { data } = await api.graphql({
        authMode,
        query: calculateRisk,
        variables: {
          ContactID,
          responses,
          resourceId,
        },
      });

      dispatch({
        payload: data?.calculateRisk,
        type: SUBMIT_ATR_COMPLETED,
      });
    } catch (error) {
      dispatch({
        payload: error,
        type: SUBMIT_ATR_FAILED,
      });
    }
  };
}

export default submitAtr;
